export const messaggiScreenshots = [
  '/messaggio1.jpg', '/messaggio2.jpg', '/messaggio3.jpg', '/messaggio4.jpg', '/messaggio5.jpg',
  '/messaggio6.jpg', '/messaggio7.jpg', '/messaggio8.jpg', '/messaggio9.jpg', '/messaggio10.jpg',
  '/messaggio11.jpg', '/messaggio12.jpg', '/messaggio13.jpg', '/messaggio14.jpg', '/messaggio15.jpg',
  '/messaggio16.jpg', '/messaggio17.jpg', '/messaggio18.jpg', '/messaggio19.jpg', '/messaggio20.jpg',
  '/messaggio21.jpg', '/messaggio22.jpg', '/messaggio23.jpg', '/messaggio24.jpg', '/messaggio25.jpg',
  '/messaggio27.jpg', '/messaggio28.jpg', '/messaggio29.jpg', '/messaggio30.jpg',
  '/messaggio31.jpg', '/messaggio32.jpg', '/messaggio33.jpg', '/messaggio34.jpg', '/messaggio35.jpg',
];

export const rassegnaStampa = [
  {
    testata: 'Presentazione Barletta',
    tipo: 'Video YouTube',
    titolo: 'Presentazione del libro a Barletta',
    url: 'https://youtu.be/WIjryfc6MMI?si=E4_pu1gvf_nM_r7x',
    icon: 'youtube',
  },
  {
    testata: 'Quarto Potere',
    tipo: 'Servizio TV',
    titolo: 'Servizio sul libro Cronache dal fronte invisibile',
    url: 'https://youtu.be/f_Of_jWGS0w?si=Jv42CtGJFiWrjZ82&sfnsn=scwspwa',
    icon: 'youtube',
  },
  {
    testata: 'Il Quarto Potere',
    tipo: 'Intervista TV',
    titolo: 'Intervista sul libro Cronache dal fronte invisibile',
    url: 'https://www.facebook.com/share/v/1DW18AJGoR/',
    icon: 'facebook',
  },
  {
    testata: 'Amica9TV',
    tipo: 'Video Facebook',
    titolo: 'Servizio sul libro Cronache dal fronte invisibile',
    url: 'https://www.facebook.com/share/v/16eGbbJX9L/',
    icon: 'facebook',
  },
  {
    testata: 'Telebari',
    tipo: 'Servizio TV',
    titolo: 'Servizio sul libro Cronache dal fronte invisibile',
    url: 'https://youtu.be/_pJbtRmHtmA?feature=shared',
    icon: 'youtube',
  },
  {
    testata: 'Antenna Sud',
    tipo: 'Articolo Online',
    titolo: 'Barletta: Cronache dal fronte invisibile - Le vicende criminali pugliesi',
    url: 'https://www.antennasud.com/barletta-cronache-dal-fronte-invisibile-in-un-libro-le-vicende-criminali-pugliesi/',
    icon: 'newspaper',
  },
  {
    testata: 'Il Fatto Quotidiano',
    tipo: 'Articolo Online',
    titolo: 'Cronache dal fronte invisibile: il libro del carabiniere Santoniccolo',
    url: 'https://www.ilfattoquotidiano.it/2026/02/07/cronache-dal-fronte-invisibile-libro-saverio-santoniccolo-carabiniere-barletta/8281205/',
    icon: 'newspaper',
  },
  {
    testata: 'Stato Quotidiano',
    tipo: 'Articolo Online',
    titolo: 'Santoniccolo racconta 41 anni nei Carabinieri',
    url: 'https://www.statoquotidiano.it/03/02/2026/cronache-dal-fronte-invisibile-santoniccolo-racconta-41-anni-nei-carabinieri/1280551/',
    icon: 'newspaper',
  },
  {
    testata: 'Telesveva Notizie',
    tipo: 'Servizio TV',
    titolo: 'Il Luogotenente in congedo Santoniccolo racconta 41 anni di servizio',
    url: 'https://telesveva.it/attualita/il-luogotenente-in-congedo-santoniccolo-racconta-41-anni-di-servizio-in-cronache-dal-fronte-invisibile-dalla-strage-di-san-marco-in-lamis-al-ritrovamento-di-graziella-mansi/',
    icon: 'tv',
  },
  {
    testata: 'BarlettaNews24',
    tipo: 'Articolo Online',
    titolo: 'Il Luogotenente Santoniccolo presenta il suo libro',
    url: 'https://barletta.news24.city/2026/02/02/il-luogotenente-in-congedo-santoniccolo-presenta-il-suo-libro-cronache-dal-fronte-invisibile/?amp=1',
    icon: 'newspaper',
  },
  {
    testata: 'Amica9',
    tipo: 'Trasmissione TV',
    titolo: 'Gran Caffè di Sera - Intervista sul libro',
    url: 'https://youtu.be/TbVLUQ7mVfs?si=td_UGSBYUzF4Gm6V',
    icon: 'youtube',
  },
  {
    testata: 'Barlettaviva',
    tipo: 'Articolo Facebook',
    titolo: 'Presentazione del libro a Barletta',
    url: 'https://www.facebook.com/share/17vC9jzTTV/',
    icon: 'facebook',
  },
  {
    testata: 'Andriaviva',
    tipo: 'Articolo Online',
    titolo: 'Dal ritrovamento di Graziella Mansi al fronte invisibile delle indagini',
    url: 'https://www.andriaviva.it/notizie/dal-ritrovamento-di-graziella-mansi-al-fronte-invisibile-delle-indagini/',
    icon: 'newspaper',
  },
  {
    testata: 'Andrialive',
    tipo: 'Articolo Online',
    titolo: 'Il racconto di chi ritrovò Graziella Mansi',
    url: 'https://andrialive.it/2026/01/15/il-racconto-di-chi-ritrovo-graziella-mansi/',
    icon: 'newspaper',
  },
];
